module.exports = __webpack_public_path__ + "img/play.b8439328.png";